const Mn = require('backbone.marionette');

const ResultadoView = require('./resultado');

const View = Mn.CollectionView.extend({
	tagName: 'ul',
	className: 'small-block-grid-1 medium-block-grid-3 large-block-grid-4',
	childView: ResultadoView
});

module.exports = View;


//////////////////
// WEBPACK FOOTER
// ./views/busca/resultados.js
// module id = 53
// module chunks = 0